/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErroResponse,
  PaginaDeTempoAtivoResponse,
  PaginaDeUsoPorUsuarioResponse,
  PreferenciasResponse,
  RelatoriosControllerExportarPreferenciasCsvParams,
  RelatoriosControllerExportarTempoAtivoCsvParams,
  RelatoriosControllerExportarUsoPorUsuarioCsvParams,
  RelatoriosControllerPreferenciasParams,
  RelatoriosControllerTempoAtivoParams,
  RelatoriosControllerUsoPorUsuarioParams
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getRelatoriosControllerUsoPorUsuarioUrl = (params?: RelatoriosControllerUsoPorUsuarioParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/relatorios/uso-por-usuario?${stringifiedParams}` : `/v1/admin/relatorios/uso-por-usuario`
}

/**
 * @summary Contagem de pacientes/exames/requisições/receituários/discussões por usuário
 */
export const relatoriosControllerUsoPorUsuario = async (params?: RelatoriosControllerUsoPorUsuarioParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeUsoPorUsuarioResponse> => {

  return httpClient<PaginaDeUsoPorUsuarioResponse>(getRelatoriosControllerUsoPorUsuarioUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRelatoriosControllerUsoPorUsuarioQueryKey = (params?: RelatoriosControllerUsoPorUsuarioParams,) => {
    return [
    `/v1/admin/relatorios/uso-por-usuario`, ...(params ? [params] : [])
    ] as const;
    }


export const getRelatoriosControllerUsoPorUsuarioQueryOptions = <TData = Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError = ErroResponse>(params?: RelatoriosControllerUsoPorUsuarioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRelatoriosControllerUsoPorUsuarioQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>> = ({ signal }) => relatoriosControllerUsoPorUsuario(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RelatoriosControllerUsoPorUsuarioQueryResult = NonNullable<Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>>
export type RelatoriosControllerUsoPorUsuarioQueryError = ErroResponse


export function useRelatoriosControllerUsoPorUsuario<TData = Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError = ErroResponse>(
 params: undefined |  RelatoriosControllerUsoPorUsuarioParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerUsoPorUsuario<TData = Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError = ErroResponse>(
 params?: RelatoriosControllerUsoPorUsuarioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerUsoPorUsuario<TData = Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError = ErroResponse>(
 params?: RelatoriosControllerUsoPorUsuarioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Contagem de pacientes/exames/requisições/receituários/discussões por usuário
 */

export function useRelatoriosControllerUsoPorUsuario<TData = Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError = ErroResponse>(
 params?: RelatoriosControllerUsoPorUsuarioParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerUsoPorUsuario>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRelatoriosControllerUsoPorUsuarioQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRelatoriosControllerExportarUsoPorUsuarioCsvUrl = (params?: RelatoriosControllerExportarUsoPorUsuarioCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/relatorios/uso-por-usuario/exportar.csv?${stringifiedParams}` : `/v1/admin/relatorios/uso-por-usuario/exportar.csv`
}

/**
 * Sem filtro nenhum: dump completo. Com `busca`/`tenantId`/`uf`, MESMO recorte da tela; `desde`/`ate` limitam por `Profile.criadoEm` — só fazem sentido aqui, a tela não tem período.
 * @summary Exporta "Uso por usuário" em CSV
 */
export const relatoriosControllerExportarUsoPorUsuarioCsv = async (params?: RelatoriosControllerExportarUsoPorUsuarioCsvParams, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getRelatoriosControllerExportarUsoPorUsuarioCsvUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRelatoriosControllerExportarUsoPorUsuarioCsvQueryKey = (params?: RelatoriosControllerExportarUsoPorUsuarioCsvParams,) => {
    return [
    `/v1/admin/relatorios/uso-por-usuario/exportar.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getRelatoriosControllerExportarUsoPorUsuarioCsvQueryOptions = <TData = Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError = unknown>(params?: RelatoriosControllerExportarUsoPorUsuarioCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRelatoriosControllerExportarUsoPorUsuarioCsvQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>> = ({ signal }) => relatoriosControllerExportarUsoPorUsuarioCsv(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RelatoriosControllerExportarUsoPorUsuarioCsvQueryResult = NonNullable<Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>>
export type RelatoriosControllerExportarUsoPorUsuarioCsvQueryError = unknown


export function useRelatoriosControllerExportarUsoPorUsuarioCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError = unknown>(
 params: undefined |  RelatoriosControllerExportarUsoPorUsuarioCsvParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerExportarUsoPorUsuarioCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError = unknown>(
 params?: RelatoriosControllerExportarUsoPorUsuarioCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerExportarUsoPorUsuarioCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError = unknown>(
 params?: RelatoriosControllerExportarUsoPorUsuarioCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Exporta "Uso por usuário" em CSV
 */

export function useRelatoriosControllerExportarUsoPorUsuarioCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError = unknown>(
 params?: RelatoriosControllerExportarUsoPorUsuarioCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarUsoPorUsuarioCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRelatoriosControllerExportarUsoPorUsuarioCsvQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRelatoriosControllerTempoAtivoUrl = (params?: RelatoriosControllerTempoAtivoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/relatorios/tempo-ativo?${stringifiedParams}` : `/v1/admin/relatorios/tempo-ativo`
}

/**
 * @summary Minutos ativos por usuário (heartbeat), somados no período
 */
export const relatoriosControllerTempoAtivo = async (params?: RelatoriosControllerTempoAtivoParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeTempoAtivoResponse> => {

  return httpClient<PaginaDeTempoAtivoResponse>(getRelatoriosControllerTempoAtivoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRelatoriosControllerTempoAtivoQueryKey = (params?: RelatoriosControllerTempoAtivoParams,) => {
    return [
    `/v1/admin/relatorios/tempo-ativo`, ...(params ? [params] : [])
    ] as const;
    }


export const getRelatoriosControllerTempoAtivoQueryOptions = <TData = Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError = ErroResponse>(params?: RelatoriosControllerTempoAtivoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRelatoriosControllerTempoAtivoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>> = ({ signal }) => relatoriosControllerTempoAtivo(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RelatoriosControllerTempoAtivoQueryResult = NonNullable<Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>>
export type RelatoriosControllerTempoAtivoQueryError = ErroResponse


export function useRelatoriosControllerTempoAtivo<TData = Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError = ErroResponse>(
 params: undefined |  RelatoriosControllerTempoAtivoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerTempoAtivo<TData = Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError = ErroResponse>(
 params?: RelatoriosControllerTempoAtivoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerTempoAtivo<TData = Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError = ErroResponse>(
 params?: RelatoriosControllerTempoAtivoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Minutos ativos por usuário (heartbeat), somados no período
 */

export function useRelatoriosControllerTempoAtivo<TData = Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError = ErroResponse>(
 params?: RelatoriosControllerTempoAtivoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerTempoAtivo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRelatoriosControllerTempoAtivoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRelatoriosControllerExportarTempoAtivoCsvUrl = (params?: RelatoriosControllerExportarTempoAtivoCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/relatorios/tempo-ativo/exportar.csv?${stringifiedParams}` : `/v1/admin/relatorios/tempo-ativo/exportar.csv`
}

/**
 * Sem `desde`/`ate`, soma o HISTÓRICO INTEIRO — diferente da tela, que sem período assume os últimos 7 dias. Com `desde`/`ate`, idêntico ao que a tela já mostra.
 * @summary Exporta "Tempo ativo" em CSV
 */
export const relatoriosControllerExportarTempoAtivoCsv = async (params?: RelatoriosControllerExportarTempoAtivoCsvParams, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getRelatoriosControllerExportarTempoAtivoCsvUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRelatoriosControllerExportarTempoAtivoCsvQueryKey = (params?: RelatoriosControllerExportarTempoAtivoCsvParams,) => {
    return [
    `/v1/admin/relatorios/tempo-ativo/exportar.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getRelatoriosControllerExportarTempoAtivoCsvQueryOptions = <TData = Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError = unknown>(params?: RelatoriosControllerExportarTempoAtivoCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRelatoriosControllerExportarTempoAtivoCsvQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>> = ({ signal }) => relatoriosControllerExportarTempoAtivoCsv(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RelatoriosControllerExportarTempoAtivoCsvQueryResult = NonNullable<Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>>
export type RelatoriosControllerExportarTempoAtivoCsvQueryError = unknown


export function useRelatoriosControllerExportarTempoAtivoCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError = unknown>(
 params: undefined |  RelatoriosControllerExportarTempoAtivoCsvParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerExportarTempoAtivoCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError = unknown>(
 params?: RelatoriosControllerExportarTempoAtivoCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerExportarTempoAtivoCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError = unknown>(
 params?: RelatoriosControllerExportarTempoAtivoCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Exporta "Tempo ativo" em CSV
 */

export function useRelatoriosControllerExportarTempoAtivoCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError = unknown>(
 params?: RelatoriosControllerExportarTempoAtivoCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarTempoAtivoCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRelatoriosControllerExportarTempoAtivoCsvQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRelatoriosControllerPreferenciasUrl = (params?: RelatoriosControllerPreferenciasParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/relatorios/preferencias?${stringifiedParams}` : `/v1/admin/relatorios/preferencias`
}

/**
 * @summary Ranking dos módulos por volume total de registros
 */
export const relatoriosControllerPreferencias = async (params?: RelatoriosControllerPreferenciasParams, options?: Parameters<typeof httpClient>[1]): Promise<PreferenciasResponse> => {

  return httpClient<PreferenciasResponse>(getRelatoriosControllerPreferenciasUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRelatoriosControllerPreferenciasQueryKey = (params?: RelatoriosControllerPreferenciasParams,) => {
    return [
    `/v1/admin/relatorios/preferencias`, ...(params ? [params] : [])
    ] as const;
    }


export const getRelatoriosControllerPreferenciasQueryOptions = <TData = Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError = ErroResponse>(params?: RelatoriosControllerPreferenciasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRelatoriosControllerPreferenciasQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof relatoriosControllerPreferencias>>> = ({ signal }) => relatoriosControllerPreferencias(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RelatoriosControllerPreferenciasQueryResult = NonNullable<Awaited<ReturnType<typeof relatoriosControllerPreferencias>>>
export type RelatoriosControllerPreferenciasQueryError = ErroResponse


export function useRelatoriosControllerPreferencias<TData = Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError = ErroResponse>(
 params: undefined |  RelatoriosControllerPreferenciasParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerPreferencias>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerPreferencias>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerPreferencias<TData = Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError = ErroResponse>(
 params?: RelatoriosControllerPreferenciasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerPreferencias>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerPreferencias>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerPreferencias<TData = Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError = ErroResponse>(
 params?: RelatoriosControllerPreferenciasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ranking dos módulos por volume total de registros
 */

export function useRelatoriosControllerPreferencias<TData = Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError = ErroResponse>(
 params?: RelatoriosControllerPreferenciasParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerPreferencias>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRelatoriosControllerPreferenciasQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRelatoriosControllerExportarPreferenciasCsvUrl = (params?: RelatoriosControllerExportarPreferenciasCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/relatorios/preferencias/exportar.csv?${stringifiedParams}` : `/v1/admin/relatorios/preferencias/exportar.csv`
}

/**
 * Sem `desde`/`ate`, MESMO comportamento da tela (volume total, sem data). Com `desde`/`ate`, conta só os registros criados (discussão técnica: abertos) no intervalo — pergunta nova, que a tela não faz.
 * @summary Exporta "Preferências" em CSV
 */
export const relatoriosControllerExportarPreferenciasCsv = async (params?: RelatoriosControllerExportarPreferenciasCsvParams, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getRelatoriosControllerExportarPreferenciasCsvUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getRelatoriosControllerExportarPreferenciasCsvQueryKey = (params?: RelatoriosControllerExportarPreferenciasCsvParams,) => {
    return [
    `/v1/admin/relatorios/preferencias/exportar.csv`, ...(params ? [params] : [])
    ] as const;
    }


export const getRelatoriosControllerExportarPreferenciasCsvQueryOptions = <TData = Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError = unknown>(params?: RelatoriosControllerExportarPreferenciasCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getRelatoriosControllerExportarPreferenciasCsvQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>> = ({ signal }) => relatoriosControllerExportarPreferenciasCsv(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type RelatoriosControllerExportarPreferenciasCsvQueryResult = NonNullable<Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>>
export type RelatoriosControllerExportarPreferenciasCsvQueryError = unknown


export function useRelatoriosControllerExportarPreferenciasCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError = unknown>(
 params: undefined |  RelatoriosControllerExportarPreferenciasCsvParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerExportarPreferenciasCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError = unknown>(
 params?: RelatoriosControllerExportarPreferenciasCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>,
          TError,
          Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useRelatoriosControllerExportarPreferenciasCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError = unknown>(
 params?: RelatoriosControllerExportarPreferenciasCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Exporta "Preferências" em CSV
 */

export function useRelatoriosControllerExportarPreferenciasCsv<TData = Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError = unknown>(
 params?: RelatoriosControllerExportarPreferenciasCsvParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof relatoriosControllerExportarPreferenciasCsv>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getRelatoriosControllerExportarPreferenciasCsvQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






